import React from 'react';
import useDonutChart from './hooks/useDonutChart';
import ChartContainer from '../Services/charts/apex-charts/ChartContainer';

export const Donut = ({ 
    chartData = [],
    subtitles,
    colors,
    title,
    height = 300,
    className = '',
    isMoney = false,
    series = null
 }) => {
    const { chartConfig } = useDonutChart({
        chartData,
        subtitles,
        colors,
        isMoney,
        series
    });


    return (
        <ChartContainer
            title={title}
            options={chartConfig.options}
            series={chartConfig.series}
            height={height}
            type="donut"
            className={className}
        />
    );
};
